/* eslint-disable no-restricted-imports */

import type { QueryClient, UseQueryOptions } from '@tanstack/react-query';
export * from '@tanstack/react-query';
export * from '@tanstack/react-query-devtools';

export { DefaultQueryProvider } from './DefaultQueryProvider';

export const tsClientOptions = {
  queryOptions: {
    retry: false,
  },
  mutationOptions: {},
} as const;

/**
 * Helper function to preload
 */
export async function prefetchQuery<T>(queryClient: QueryClient, query: UseQueryOptions<T>) {
  await queryClient.prefetchQuery(query);
  return queryClient.getQueryData<T>(query.queryKey) as T; // note: safe due to prefetch
}
